import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store/configureStore';
import AuthedSidebar from './authedSidebar';
import { admAccounts, programFiles } from 'const';

const Sidebar = () => {
  const routes = [];
  for ( const ii in admAccounts ) {
    routes.push(<Route exact key={admAccounts[ii]} path={admAccounts[ii]}  component={AuthedSidebar}></Route>);
  }
  for ( const ii in programFiles ) {
    routes.push(<Route exact key={programFiles[ii]} path={programFiles[ii]}  component={AuthedSidebar}></Route>);
  }
  return (
    <ConnectedRouter history={history}>
      <Switch>
        {routes}
      </Switch>
    </ConnectedRouter>
  );
};

export default Sidebar;